// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__HWGH8","inputWrap":"Table_inputWrap__WDHZ0","col":"Table_col__2Ay3i","bmiTooltip":"Table_bmiTooltip__1YFMT"};